module.exports = __webpack_public_path__ + "assets/adpoly-facility-classrooms-bulk-upload-template.a81fe974.xlsx";